import { DEFAULT_FORM_DATA } from '../constants';

// Reducer to handle all form data updates
export const formDataReducer = (state, action) => {
  //console.log('Reducer action:', action);
  switch (action.type) {
    case 'UPDATE_LEG_FIELD':
      return {
        ...state,
        legs: state.legs.map((leg, idx) => 
          idx === action.legIndex 
            ? { ...leg, [action.field]: action.value }
            : leg
        )
      };

    case 'UPDATE_PRODUCT_FIELD':
      return {
        ...state,
        legs: state.legs.map((leg, idx) => 
          idx === action.legIndex 
            ? {
                ...leg,
                selectedProducts: leg.selectedProducts.map(product => {
                  if (product.product_id === action.productId) {
                    return { ...product, [action.field]: action.value };
                  }
                  return product;
                })
              }
            : leg
        )
      };

    case 'REMOVE_PRODUCT':
      return {
        ...state,
        legs: state.legs.map((leg, idx) => 
          idx === action.legIndex 
            ? {
                ...leg,
                selectedProducts: leg.selectedProducts.filter(product => product.product_id !== action.productId)
              }
            : leg
        )
      };
    case 'ADD_PRODUCT':
      return {
        ...state,
        legs: state.legs.map((leg, idx) => 
          idx === action.legIndex 
            ? {   ...leg, selectedProducts: [...leg.selectedProducts, action.product] }
            : leg
        )
      };

    case 'BATCH_LEG_UPDATES':
      return {
        ...state,
        legs: state.legs.map((leg, idx) => 
          idx === action.legIndex 
            ? { ...leg, ...action.updates }
            : leg
        )
      };

    case 'UPDATE_BOOKING_DATA':
      return {
        ...state,
        legs: state.legs.map((leg, index) => 
          index === 0 ? {
            ...leg,
            fromAddress: action.from,
            toAddress: action.to,
            pricing: action.pricing,
            tripType: { id: 'one-way', label: 'One Way' }
          } : leg
        )
      };

    case 'ADD_LEG':
      return {
        ...state,
        legs: [...state.legs, action.leg],
        tabs: [...state.tabs, {
          id: `tab-${action.leg.legIndex}`,
          title: `Leg ${state.legs.length + 1}`,
          subtitle: '',
          price: '0.00',
          closable: true
        }]
      };

    case 'REMOVE_LEG':
      return {
        ...state,
        legs: state.legs
          .filter((_, index) => index !== action.legIndex)
          .map((leg, index) => (
            { 
              ...leg,
              id: `leg-${index}`, 
              legIndex: index 
            })), // Re-index legs
        tabs: state.tabs
          .filter((_, index) => index !== action.legIndex)
          .map((tab, index) => (
            { 
              ...tab,
              id: `tab-${index}`, 
              title: `Leg ${index + 1}` 
            })) // Re-index tabs
      };

    case 'UPDATE_FORM_FIELD':
      return {
        ...state,
        [action.field]: action.value
      };

    case 'UPDATE_FORM_FIELDS':
      return {
        ...state,
        ...action.updates
      };
    case 'SET_CURRENT_PAGE':
      return { 
        ...state, 
        currentPage: {
          index: action.index,
          current: action.value,
          previous: state.currentPage?.current || null
        }
      };
    case 'SET_CRUISE_DATA':
      return { 
        ...state, 
        cruiseData: action.data 
      };

    case 'UPDATE_CRUISE_DATA':
      return { 
        ...state, 
        cruiseData: state.cruiseData.map(cruise => 
          cruise.id === action.id ? { ...cruise, ...action.data } : cruise
        )
      };

    case 'SET_CURRENT_CRUISE_LINE':
      return { 
        ...state, 
        currentCruiseLine: action.cruiseLine 
      };

    case 'UPDATE_ITINERARY_FILTER':
      return {
        ...state,
        itineraryFilterField: action.field,
        itineraryFilterLabel: action.label
      };

    case 'UPDATE_CUSTOMER_INFO':
      return {
        ...state,
        customerInfo: { ...state.customerInfo, ...action.updates }
      };

    case 'UPDATE_PAYMENT_INFO':
      return {
        ...state,
        paymentInfo: { ...state.paymentInfo, ...action.updates }
      };

    case 'SET_AGENT_ID':
      return { ...state, agentId: action.agentId };

    case 'SET_ADVISOR_DATA':
      return { ...state, advisorData: action.data };

    case 'RESET_FORM':
      return DEFAULT_FORM_DATA;

    case 'SET_FORM_DATA':
      return action.data;

    case 'SET_FORM_DATA_FUNCTION':
      return action.updater(state);

    default:
      console.warn(`Unknown action type: ${action.type}`);
      return state;
  }
};
